module.exports = __webpack_public_path__ + "img/facebook-ad.4b116791.png";